import { registerComponent } from '../app'
import Cart from '../services/Cart'
import { OPEN_CART } from '../events'

const ATCButton = (scope, el) => {
	const props = {
		id: el.getAttribute('data-variant'),
		loadingClass: 'button--loading',
		productInfo: JSON.parse(
			document.getElementById('product-data-' + el.getAttribute('data-product-id')).innerHTML
		)
	}

	el.addEventListener('click', e => {
		e.preventDefault()

		el.classList.add(props.loadingClass)

		let data = {
			id: props.id,
			quantity: 1,
			properties: {
				is_subscription: false,
				product_title: props.productInfo.title,
				compare_at_price: props.productInfo.compare_at_price,
				image: props.productInfo.image
			}
		}

		Cart.addItem(data).then(() => {
			el.classList.remove(props.loadingClass)

			// dispatch events

			scope.emit(OPEN_CART)

			const event = new CustomEvent('addedToCart', {
				bubbles: true,
				cancelable: true,
				detail: data
			})
		})
	})
}

registerComponent('atc-button', ATCButton)
